module.exports = __webpack_public_path__ + "static/media/space-food_007.6db9fc1f.jpg";